var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 12C1.25 16.9125 4.4 21.075 8.75 22.6125V1.3875C4.4 2.925 1.25 7.0875 1.25 12ZM23.75 12C23.75 7.0875 20.6375 2.925 16.25 1.3875V22.6125C20.6375 21.075 23.75 16.9125 23.75 12Z",
    fill: "#83BF4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 22.6125C9.9125 23.025 11.1875 23.25 12.5 23.25C13.8125 23.25 15.0875 23.025 16.25 22.6125V1.3875C15.0875 0.975 13.8125 0.75 12.5 0.75C11.1875 0.75 9.9125 0.975 8.75 1.3875V22.6125Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNg);
export default __webpack_public_path__ + "static/media/ng.d0a05a9e91181ef00f356d0545de9132.svg";
export { ForwardRef as ReactComponent };